export const caseStudies = [
  {
    id: 1,
    slug: 'trafik-vardi-satis-yoktu',
    title: "Trafik Vardı, Satış Yoktu",
    category: "E-Ticaret",
    datePublished: '2025-03-15',
    problem:
      "Mağaza ciddi trafik alıyordu. Ziyaretçiler ürünlere bakıyor, sepete ekliyor, sonra kayboluyordu. Reklam bütçesi her ay büyüyor, dönüşüm aynı yerde duruyordu.",
    insight:
      "Sorun reklamda değildi. Kullanıcıların sepeti terk ettiği anı izlediğimizde, asıl kırılmanın ödeme adımındaki beklenmedik maliyetler ve eksik güven sinyallerinde olduğunu gördük.",
    strategy:
      "Satın alma yolculuğunu uçtan uca haritaladık. Her kırılma noktası için ayrı bir iyileştirme planı çıkardık; önce en çok müşteri kaybeden adımı düzelttik.",
    execution:
      "Checkout akışı sadeleştirildi, beklenmedik maliyetler öne çekildi, güven sinyalleri güçlendirildi ve sepeti terk edenlere akıllı geri dönüş kurgulandı.",
    result:
      "Satış hunisindeki kırılma noktaları tek tek onarıldı. Sepetten ödemeye geçiş, müdahale öncesine göre belirgin şekilde arttı ve reklam bütçesi artık boşa yanmıyor.",
    learning:
      "Trafik sorunu sandığınız şey, çoğu zaman dönüşüm sorunudur. Önce huniyi onarın, sonra trafiği büyütün.",
    gradient: "from-primary-500 to-primary-700",
  },
  {
    id: 2,
    slug: 'satis-ekibi-bos-lead-yok',
    title: "Satış Ekibi Boş, Lead Yok",
    category: "B2B",
    datePublished: '2025-07-22',
    problem:
      "Endüstriyel bir firma yıllardır referansla satış yapıyordu. Yeni müşteri kazanmak için sistematik bir yöntem yoktu; satış ekibi fırsat bekliyordu.",
    insight:
      "Firmanın asıl değeri teknik uzmanlığıydı, ama bu uzmanlık dışarıya hiç anlatılmıyordu. Karar vericiler markayı hiçbir dijital kanalda bulamıyordu.",
    strategy:
      "Teknik birikimi, karar vericilerin aradığı içerik ve mesajlara dönüştüren bir lead generation sistemi kurduk. LinkedIn ve sektörel SEO'yu aynı anlatı etrafında birleştirdik.",
    execution:
      "LinkedIn'de hedefli erişim, sektörel içerik üretimi, teknik dokümanların karar verici diline çevrilmesi ve lead'lerin skorlanarak satışa aktarılması.",
    result:
      "Sistematik bir lead akışı başladı. Gelen lead'ler satış ekibinin doğrudan kullanabileceği şekilde nitelendirilmiş olarak aktarıldı.",
    learning:
      "Teknik ürünü satan şey teknik özellik değil, o ürünün hangi sorunu çözdüğünün net anlatılmasıdır.",
    gradient: "from-accent-500 to-accent-700",
  },
  {
    id: 3,
    slug: 'eskimis-marka-kaybolan-itibar',
    title: "Eskimiş Marka, Kaybolan İtibar",
    category: "Marka",
    datePublished: '2026-01-10',
    problem:
      "Yıllardır sektörde olan bir marka dijitalde görünmez hale gelmişti. Yeni rakipler daha agresif, daha görünürdü. Markanın söylediği ile pazarın anladığı artık aynı değildi.",
    insight:
      "Markanın sorunu ürün değil, konumlandırmaydı. Herkese her şeyi anlatmaya çalışıyor, kimse için net bir anlam ifade etmiyordu.",
    strategy:
      "Markayı tek bir güçlü konumlandırmaya oturttuk. Mesajı, görsel dili ve dijital varlığı bu konumlandırma etrafında yeniden kurduk.",
    execution:
      "Konumlandırma çalışması, yeni mesaj mimarisi ve web sitesi ile tüm dijital varlığın bu anlatıya göre yenilenmesi.",
    result:
      "Marka pazarda yeniden net bir anlam ifade etmeye başladı. İletişim tutarlı hale geldi; içeride ve dışarıda herkes aynı şeyi anlatıyor.",
    learning:
      "Görünür olmak yetmez. Doğru algılanmak gerekir. Konumlandırma olmadan yapılan her iletişim, bütçeyi boşa harcar.",
    gradient: "from-secondary-500 to-secondary-700",
  },
];